var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoPart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 648,
    height: 952,
    viewBox: "0 0 648 952",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_158_5773)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M496.001 476.126C456.699 409.837 435.899 332.653 436.104 253.856C436.065 230.123 437.887 206.43 441.549 183.031L440.133 181.378C401.948 140.106 352.537 113.225 299.187 104.701C245.836 96.1769 191.371 106.46 143.823 134.035C96.2739 161.609 58.1583 205.015 35.0967 257.851C12.0351 310.688 5.24807 370.158 15.7365 427.493V427.906C47.0761 598.435 124.416 755.04 237.954 877.877L546.749 544.353C527.676 523.599 510.667 500.732 496.001 476.126V476.126Z",
    fill: "url(#paint0_linear_158_5773)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.806 421.001L1091.97 885.786C1111.39 906.755 1134.42 923.374 1159.76 934.693C1185.1 946.012 1212.25 951.81 1239.65 951.755C1267.06 951.7 1294.19 945.794 1319.49 934.374C1344.79 922.953 1367.76 906.243 1387.1 885.196V885.196C1542.56 716.103 1632.84 487.458 1631.59 248.721C1631.31 192.122 1626.06 135.68 1615.91 80.159C1626.38 137.489 1619.58 196.949 1596.52 249.774C1573.45 302.598 1535.33 345.992 1487.79 373.557C1440.24 401.123 1385.79 411.401 1332.44 402.877C1279.1 394.353 1229.7 367.479 1191.51 326.215L1190.1 324.562L969.894 87.0055L539.725 -377.72C500.521 -420.063 447.405 -443.794 392.06 -443.694C336.715 -443.595 283.672 -419.673 244.597 -377.189V-377.189C89.083 -208.096 -1.14331 20.5483 0.0546265 259.285C0.342498 315.904 5.59349 372.365 15.7367 427.907C5.24832 370.572 12.0353 311.101 35.0969 258.265C58.1586 205.428 96.2741 162.022 143.823 134.448C191.372 106.874 245.837 96.5901 299.187 105.114C352.537 113.639 401.948 140.52 440.133 181.792L441.549 183.444L661.806 421.001Z",
    fill: "#2563EB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_158_5773",
    x1: 235.395,
    y1: 117.873,
    x2: 337.562,
    y2: 820.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0C77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2563EB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_158_5773"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1631.7,
    height: 1395.77,
    fill: "white",
    transform: "translate(0 -444)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPart);
export default __webpack_public_path__ + "static/media/logoPart.118efea161583c753bd542d24e6070d4.svg";
export { ForwardRef as ReactComponent };